import { __extends } from "tslib";
import { Info } from './Info';
var ClassInfo = /** @class */ (function (_super) {
    __extends(ClassInfo, _super);
    function ClassInfo(abc, instanceInfo, methodInfo, traits) {
        var _this = _super.call(this, traits) || this;
        _this.abc = abc;
        _this.instanceInfo = instanceInfo;
        _this.methodInfo = methodInfo;
        _this.traits = traits;
        _this.global = null;
        _this.trait = null;
        _this.runtimeTraits = null;
        return _this;
    }
    ClassInfo.prototype.getNativeMetadata = function () {
        var _a;
        var metadata = (_a = this.trait) === null || _a === void 0 ? void 0 : _a.metadata;
        if (!metadata)
            return null;
        for (var i = 0; i < metadata.length; i++)
            if (metadata[i].name === 'native')
                return metadata[i];
        return null;
    };
    ClassInfo.prototype.toString = function () {
        return 'ClassInfo ' + this.instanceInfo.multiname;
    };
    ClassInfo.prototype.trace = function (writer) {
        writer.enter('ClassInfo');
        this.traits.trace(writer);
        writer.outdent();
    };
    return ClassInfo;
}(Info));
export { ClassInfo };
